import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'rappider-ui-client-pages',
  templateUrl: './ui-client-pages.component.html',
  styleUrls: ['./ui-client-pages.component.scss']
})
export class UiClientPagesComponent implements OnInit {

  ngOnInit(): void {
    console.log('Component initialized.');
  }

}
